import React, { Fragment } from "react";
import { translate } from "../Services/translation";

const SettingsBanner = ({ shouldShowContractedAssortment, toggle }) => {

	return (
		<Fragment>
			<div className="settingsbanner">
				<div className="settingsbanner__container">
					<div className="settingsbanner__items">
						<Checkbox label={translate('settingsbanner.limitedAssortment')} onCheckboxChange={toggle} isChecked={shouldShowContractedAssortment} />
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default SettingsBanner;

export const Checkbox = ({ label, onCheckboxChange, isChecked }) => (
	<label className="inputfield__checkbox-container">
		<input className="inputfield__checkbox-input" type="checkbox" checked={isChecked} onChange={event => onCheckboxChange()} />
		<span className="inputfield__checkbox">
			{label}
		</span>
	</label>
)
